import { useEffect, useState, useCallback, useRef } from 'react'

interface UseOTPCounterProps {
  initialValue: number
  interval?: number
}

interface UseOTPCounterReturn {
  count: number
  start: () => void
  reset: () => void
}

export const useOTPCounter = ({ initialValue, interval = 1000 }: UseOTPCounterProps): UseOTPCounterReturn => {
  const [count, setCount] = useState<number>(initialValue)
  const intervalRef = useRef<NodeJS.Timeout | null>(null)

  const start = () => {
    setCount(initialValue)
  }

  const reset = () => {
    setCount(initialValue)
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }
  }

  useEffect(() => {
    if (count > 0) {
      intervalRef.current = setInterval(() => {
        setCount(prevCount => {
          const newCount = prevCount - 1
          if (newCount <= 0) {
            return 0
          }
          return newCount
        })
      }, interval)
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }
    }
  }, [count, interval])

  return {
    count,
    start,
    reset
  }
}
